import { t } from "i18next";

import { GameActivity } from "../enum/GameActivity";

import { boolean } from "yup";
import { PAYMENT_OPTIONS } from "../constant/constants";

export const otherFiltersList = [
  {
    key: "GameActivity",
    label: t("statisticPage.header.filter.gameActivity"),
    type: "radio",
    options: [
      {
        ID: GameActivity.ALL,
        Name: t("statisticPage.header.filter.dropdown.gameActivity.all"),
      },
      {
        ID: GameActivity.WITH,
        Name: t("statisticPage.header.filter.dropdown.gameActivity.with"),
      },
      {
        ID: GameActivity.WITHOUT,
        Name: t("statisticPage.header.filter.dropdown.gameActivity.without"),
      },
    ],
  },
  {
    key: "PaymentSource",
    label: t("statisticPage.header.filter.paymentSource"),
    type: "checkbox",
    options: PAYMENT_OPTIONS.map((opt) => ({
      ID: opt.ID,
      Name: opt.Name,
    })),
    hasSwitch: true,
    switchValue: boolean,
    switchLabel: t("statisticPage.header.filter.dropdown.paymentSource.sum"),
  },
  {
    key: "Games",
    label: t("statisticPage.header.filter.games"),
    type: "checkbox",
    search: true,
  },
  {
    key: "TestData",
    label: t("statisticPage.header.filter.testData"),
    type: "radio",
    options: [
      {
        ID: true,
        Name: t("statisticPage.header.filter.dropdown.testData.yes"),
      },
      {
        ID: false,
        Name: t("statisticPage.header.filter.dropdown.testData.no"),
      },
    ],
  },
];
